// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBRHPOlOIxVdrA4uwgeGg_Ffj797XEvXLM",
  authDomain: "metodoalps.firebaseapp.com",
  projectId: "metodoalps",
  storageBucket: "metodoalps.firebasestorage.app",
  messagingSenderId: "635826899314",
  appId: "1:635826899314:web:c788daa5a2edcb51a735eb"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize and export Firestore with specific database
export const db = initializeFirestore(app, {}, "student-db");
